// extracted by mini-css-extract-plugin
export default {"wrapper":"_1cvk0n1OqtxTmiLZ7moGaQ==","qrCodeContainer":"Zc2bcGEXoHalKv9C4aytlQ==","qrCode":"nNPz9VZioy-QO7hfa75sYA==","paymentCta":"afEZc1RVTmNjry9t9gbpbg=="};